<div class="border-t-1 border-neu-100 mt-4">
  <div class="question-panel__header grid grid-cols-[auto_1fr] items-start gap-x-4 w-full mt-4">
    <kirigami-score-icons [score]="getScoreIcon(score)" [size]="'medium'" [color]="'light'" />
    <div>
      <h5 class="text-body-14 capitalize text-strong m-0!">{{ category }}</h5>
      <p>{{ problem }}</p>
      <h5 class="text-body-14 text-strong m-0!">Solution</h5>
      <p>{{ solution }}</p>
    </div>
  </div>
</div>
